import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Area = apiContainer.Area
//GET--->
// Corrected getArea function
export async function getAreaApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Area}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createArea(request) {
    try {
        return api.create(`${Area}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateArea(request, AreaId) {
    try {
        return api.update(`${Area}/${AreaId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteArea(AreaId) {
    try {
        return api.delete(`${Area}/${AreaId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



